module.exports = __webpack_public_path__ + "static/media/mercadotecnia.f749cbea.jpg";